module.exports = __webpack_public_path__ + "img/title1.6ca9a3b5.png";